import { Kbd } from "../Kbd";

/** Footer del modal con hints de teclado: ↑↓ navegar · Enter abrir · Esc cerrar. */
export function CommandPaletteFooter() {
  return (
    <div className="flex items-center justify-between border-t border-border px-4 py-2 text-[11px]">
      <div className="flex items-center gap-1.5">
        <Kbd>↑↓</Kbd>
        <span className="text-muted-foreground">navegar</span>
        <span className="text-muted-foreground">·</span>
        <Kbd>Enter</Kbd>
        <span className="text-muted-foreground">abrir</span>
      </div>
      <div className="flex items-center gap-1.5">
        <Kbd>Esc</Kbd>
        <span className="text-muted-foreground">cerrar</span>
      </div>
    </div>
  );
}
